// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Components
import Button from './button';
import Error from './error';
import Loading from './loading';
import RecordDetails from './record-details';

// Styles
import './form-confirm.scss';

export default class FormConfirm extends Component {
    componentWillUnmount() {
        const {formSubmitReset} = this.props;

        formSubmitReset();
    }

    getClass() {
        const {className} = this.props;

        return classnames(
            {
                'form-confirm': true,
            },
            className
        );
    }

    renderCompleted() {
        const {error, fetching = false, onComplete, response} = this.props;

        return !fetching ? (
            <div className="form-confirm--message">
                <Error error={error} />
                <div className="form-confirm--message-text">{response}</div>
                <div className="form-confirm--message-buttons">
                    <Button onClick={onComplete}>Ok</Button>
                </div>
            </div>
        ) : (
            <Loading loading={fetching} />
        );
    }

    renderConfirm() {
        const {
            cancelLabel = 'Cancel',
            confirmLabel = 'Delete',
            confirmMessage = 'Are you sure you want to delete this record?',
            onCancel,
            onConfirm,
            searchData,
            whitelistKeys
        } = this.props;

        return (
            <div className={this.getClass()}>
                <RecordDetails
                    className="form-confirm--record"
                    searchData={[searchData]}
                    whitelistKeys={whitelistKeys}
                />
                <div className="form-confirm--message">{confirmMessage}</div>
                <div className="form-confirm--buttons">
                    <Button className="form-confirm--button" onClick={onCancel}>
                        {cancelLabel}
                    </Button>
                    <Button className="form-confirm--button" onClick={onConfirm}>
                        {confirmLabel}
                    </Button>
                </div>
            </div>
        );
    }

    render() {
        const {completed} = this.props;

        return completed ? this.renderCompleted() : this.renderConfirm();
    }
}

FormConfirm.propTypes = {
    cancelLabel: PropTypes.string,
    className: PropTypes.string,
    completed: PropTypes.bool,
    confirmLabel: PropTypes.string,
    confirmMessage: PropTypes.string,
    error: PropTypes.string,
    fetching: PropTypes.bool,
    formSubmitReset: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onComplete: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    response: PropTypes.string,
    searchData: PropTypes.object,
    whitelistKeys: PropTypes.arrayOf(PropTypes.string),
};
